import { TaskLocation, isShiftLocation } from "../service/DragAndDropApi";

export type IntersectionDetails = {
  destinationWorkTaskIdBefore: number | null;
  destinationWorkTaskIdAfter: number | null;
  destinationLocation: TaskLocation;
  
  // Legacy field - kept for backward compatibility
  /** @deprecated Use 'destinationLocation' instead */
  toShiftId?: number | null;
};

// Helper to create IntersectionDetails
export const createIntersectionDetails = (
  destinationWorkTaskIdBefore: number | null,
  destinationWorkTaskIdAfter: number | null,
  destinationLocation: TaskLocation
): IntersectionDetails => ({
  destinationWorkTaskIdBefore,
  destinationWorkTaskIdAfter,
  destinationLocation,
  // Maintain backward compatibility
  toShiftId: isShiftLocation(destinationLocation) ? destinationLocation.shiftId : null
});
